import { ref, reactive, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6298ea07"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bill-search-box"
};
const _hoisted_2 = {
  class: "search-part"
};
const _hoisted_3 = {
  class: "search-item"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "search-item-title"
}, "时间段", -1));
const _hoisted_5 = {
  class: "search-item-content"
};
const _hoisted_6 = {
  class: "search-item"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "search-item-title"
}, "时区", -1));
const _hoisted_8 = {
  class: "search-item-content"
};
const _hoisted_9 = {
  class: "search-item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "search-item-title"
}, "产品名", -1));
const _hoisted_11 = {
  class: "search-item-content"
};
const _hoisted_12 = {
  class: "product-item-content"
};
const _hoisted_13 = {
  class: "product-name-row"
};
const _hoisted_14 = ["title"];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1));
const _hoisted_16 = {
  class: "appListPopover-content"
};
const _hoisted_17 = {
  class: "appListPopover-content-title"
};
const _hoisted_18 = {
  class: "inf-label"
};
const _hoisted_19 = {
  class: "inf-value"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_21 = {
  class: "search-item"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "search-item-title"
}, "支付渠道", -1));
const _hoisted_23 = {
  class: "search-item-content"
};
const _hoisted_24 = {
  class: "btn-part"
};
import IncomePermissionBadge from '@/components/IncomePermissionBadge.vue';
import dayjs from 'dayjs';
import { message } from 'ant-design-vue';
import { QuestionCircleOutlined } from '@ant-design/icons-vue';
import { DynamicMultipleVirtualScrollSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
import DbtDatePicker from '@/components/DbtDatePicker.vue';
import { queryProductList, queryChannelList } from '@/api/billBoardApi';
import { getAppListInformation, copy } from '@/common';
import { timeOptions, zoneOptions } from '../data';
export default /*#__PURE__*/_defineComponent({
  __name: 'BoardHeader',
  emits: ['getFilterData'],
  setup(__props, {
    emit
  }) {
    const dynamicSelectRef = ref(null);
    const myForm = reactive({
      startDateTime: dayjs(new Date().getTime() - 7 * 24 * 3600 * 1000).format('YYYYMMDD'),
      endDateTime: dayjs(new Date().getTime() - 24 * 3600 * 1000).format('YYYYMMDD'),
      recentDay: '7-1',
      dynamic: 0,
      fromDayToDay: 0,
      useServerTime: false,
      datePeriod: 'day',
      timeZone: 'UTC-8',
      dbtIdList: [],
      payChnl: undefined
    });
    const productList = ref([]);
    const chanlList = ref([]);
    const initOptions = async () => {
      try {
        const {
          code,
          data
        } = await queryProductList(undefined, 'reconciliation');
        if (code == '0') {
          productList.value = data.map(item => {
            var _item$extData;
            return {
              ...item,
              checked: false,
              label: item.appName,
              value: item.dbtId,
              ...item.extData,
              sensitivePermission: item.sensitivePermission,
              filePath: ((_item$extData = item.extData) === null || _item$extData === void 0 ? void 0 : _item$extData.filePath) || '-'
            };
          });
          // 给产品下拉赋值
          dynamicSelectRef.value && (dynamicSelectRef.value.displayOptions = productList.value);
          // myForm.dbtIdList = [productList.value[0].value]
          // myForm.dbtIdList && (await queryChanlList())
        }
      } catch (error) {}
    };
    const queryChanlList = async () => {
      try {
        const params = myForm.dbtIdList;
        const {
          code,
          data
        } = await queryChannelList(params);
        if (code == '0' && data.pay_chnl.length) {
          var _chanlList$value$;
          chanlList.value = data.pay_chnl;
          myForm.payChnl = (_chanlList$value$ = chanlList.value[0]) === null || _chanlList$value$ === void 0 ? void 0 : _chanlList$value$.dimensionCode;
        }
      } catch (error) {}
    };
    const productChange = async () => {
      await queryChanlList();
    };
    const handleSearch = () => {
      if (!myForm.dbtIdList.length) {
        message.warning('请选择产品名称');
        return false;
      }
      if (!myForm.payChnl) {
        message.warning('请选择支付渠道');
        return false;
      }
      emit('getFilterData', myForm);
    };
    const handleReset = () => {
      myForm.startDateTime = dayjs(new Date().getTime() - 7 * 24 * 3600 * 1000).format('YYYYMMDD');
      myForm.endDateTime = dayjs(new Date().getTime() - 24 * 3600 * 1000).format('YYYYMMDD');
      myForm.recentDay = '7-1';
      myForm.dynamic = 0;
      myForm.fromDayToDay = 0;
      myForm.useServerTime = false;
      myForm.datePeriod = 'day';
      myForm.timeZone = 'UTC-8';
      myForm.dbtIdList = [];
      myForm.payChnl = undefined;
    };
    onMounted(async () => {
      await initOptions();
      // handleSearch()
    });
    return (_ctx, _cache) => {
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_select = _resolveComponent("a-select");
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(DbtDatePicker, {
        "show-use-server-time": false,
        "show-header": false,
        "show-dynamic": false,
        startTime: myForm.startDateTime,
        "onUpdate:startTime": _cache[0] || (_cache[0] = $event => myForm.startDateTime = $event),
        endTime: myForm.endDateTime,
        "onUpdate:endTime": _cache[1] || (_cache[1] = $event => myForm.endDateTime = $event),
        recentDay: myForm.recentDay,
        "onUpdate:recentDay": _cache[2] || (_cache[2] = $event => myForm.recentDay = $event),
        dynamic: myForm.dynamic,
        "onUpdate:dynamic": _cache[3] || (_cache[3] = $event => myForm.dynamic = $event),
        fromDayToDay: myForm.fromDayToDay,
        "onUpdate:fromDayToDay": _cache[4] || (_cache[4] = $event => myForm.fromDayToDay = $event),
        useServerTime: myForm.useServerTime,
        "onUpdate:useServerTime": _cache[5] || (_cache[5] = $event => myForm.useServerTime = $event),
        position: "bottomLeft"
      }, null, 8, ["startTime", "endTime", "recentDay", "dynamic", "fromDayToDay", "useServerTime"]), _createVNode(_component_a_tooltip, {
        title: "请选择时间段",
        placement: "top"
      }, {
        default: _withCtx(() => [_createVNode(_unref(QuestionCircleOutlined), {
          class: "search-item-icon"
        })]),
        _: 1
      }), _createVNode(_component_a_select, {
        value: myForm.datePeriod,
        "onUpdate:value": _cache[6] || (_cache[6] = $event => myForm.datePeriod = $event),
        options: _unref(timeOptions),
        style: {
          "width": "98px"
        }
      }, null, 8, ["value", "options"])])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_a_select, {
        value: myForm.timeZone,
        "onUpdate:value": _cache[7] || (_cache[7] = $event => myForm.timeZone = $event),
        options: _unref(zoneOptions),
        style: {
          "width": "220px"
        },
        placeholder: "请选择时区"
      }, null, 8, ["value", "options"])])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_unref(DynamicMultipleVirtualScrollSelect), {
        ref_key: "dynamicSelectRef",
        ref: dynamicSelectRef,
        modelValue: myForm.dbtIdList,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => myForm.dbtIdList = $event),
        allowClear: true,
        popupClassName: "vertical-product-select",
        placeholder: "请选择产品",
        labelField: "label",
        valueField: "value",
        width: "240px",
        "popup-class-name": "income-product-popup",
        searchFields: ['label', 'value'],
        "dropdown-max-height": 450,
        "item-height": 50,
        showDetail: true,
        maxTagCount: 1,
        onChange: productChange
      }, {
        "product-item": _withCtx(({
          item
        }) => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", {
          class: "product-name",
          title: item.label
        }, _toDisplayString(item.label), 9, _hoisted_14), item.sensitivePermission === true ? (_openBlock(), _createBlock(IncomePermissionBadge, {
          key: 0
        })) : _createCommentVNode("", true)]), _hoisted_15])]),
        detail: _withCtx(({
          detail
        }) => [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_SvgIcon, {
          iconClass: "informationIcon",
          class: "informationIcon"
        }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
          return _openBlock(), _createElementBlock("div", {
            key: child.label,
            class: "inf-line"
          }, [_createElementVNode("div", _hoisted_18, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_19, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
            placement: "top"
          }, {
            title: _withCtx(() => [_hoisted_20]),
            default: _withCtx(() => [_createVNode(_component_SvgIcon, {
              iconClass: "copy",
              class: "dbt-copyIcon",
              onClick: $event => _unref(copy)(child.value)
            }, null, 8, ["onClick"])]),
            _: 2
          }, 1024)]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, [_createVNode(_component_a_select, {
        ref: "channelSelectRef",
        width: "220px",
        value: myForm.payChnl,
        "onUpdate:value": _cache[9] || (_cache[9] = $event => myForm.payChnl = $event),
        fieldNames: {
          label: 'dimensionName',
          value: 'dimensionCode'
        },
        options: chanlList.value,
        style: {
          "width": "220px"
        },
        placeholder: "请选择支付渠道"
      }, null, 8, ["value", "options"])])])]), _createElementVNode("div", _hoisted_24, [_createVNode(_component_a_button, {
        onClick: handleReset
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: handleSearch
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])]);
    };
  }
});